




















































































































import { ContractStatus, TermContract } from "@foxone/api/src/models/defi";
import { Component, Vue, Prop } from "vue-property-decorator";
import { RevenueTimeline } from "defi/components/partial/RevenueTimeline";
import defiUtils from "defi/utils";

@Component({
  components: {
    RevenueTimeline
  }
})
class TermContractDetail extends Vue {
  @Prop() contract!: TermContract | null;

  withdrawing = false;

  get meta() {
    const utils = this.$common.utils;
    const getColor = utils.helper.getColor;
    const formatDate = (t, p = "YYYY-MM-DD") =>
      utils.date.formatDate(t * 1000, p);

    let interestRatio = 0;
    if (this.contract && "interest_ratio" in this.contract) {
      interestRatio = Number(this.contract.interest_ratio);
    }

    let statusMeta = { text: "", color: "" };
    if (this.contract?.status) {
      statusMeta = defiUtils.enums.getContractStatusMeta(this.contract.status);
    }

    const rate =
      interestRatio === 0
        ? this.$t("common.tbd")
        : utils.number.toPercent(interestRatio, true);

    const canWithdraw = this.contract?.can_withdraw ?? false;
    const isClosed = this.contract?.status === ContractStatus.CLOSED;
    const totalRevenue = this.contract?.total_revenue;
    const submitBtnText =
      this.contract?.status === ContractStatus.REDEMPTION && !canWithdraw
        ? this.$t("defi.withdrawing")
        : this.$t("defi.redempt");
    const canRedemption =
      this.contract?.status === ContractStatus.REDEMPTION && canWithdraw;
    const quantity = Number(this.contract?.quantity ?? 0);
    const duration = this.contract?.duration ?? 0;
    const expectRevenue = ((duration * quantity * interestRatio) / 365).toFixed(
      8
    );
    const expireAt = formatDate(this.contract?.expire_at ?? 0);
    const redemptionAt = formatDate(this.contract?.redemption_at ?? 0);

    let timelineItems: any[] = [];
    if (this.contract) {
      timelineItems = [
        {
          text: this.$t("defi.buy"),
          label: formatDate(this.contract.raise_at, "MM-DD")
        },
        {
          text: this.$t("defi.start-revenue"),
          label: formatDate(this.contract.interest_at, "MM-DD")
        },
        {
          text: this.$t("defi.onexpire"),
          label: formatDate(this.contract.expire_at, "MM-DD")
        },
        {
          text: this.$t("defi.redemption"),
          label: formatDate(this.contract.redemption_at, "MM-DD")
        }
      ];
    }

    return {
      rate,
      isClosed,
      expireAt,
      redemptionAt,
      canRedemption,
      timelineItems,
      expectRevenue,
      submitBtnText,
      totalRevenue,
      statusText: this.$t(statusMeta.text),
      statusColor: statusMeta.color,
      expectRevenueColor: getColor(this.$store, Number(expectRevenue)),
      symbol: this.contract?.pay_asset.symbol.toUpperCase(),
      quantity: this.contract?.quantity,
      name: this.contract?.name,
      icon: this.contract?.pay_asset.icon,
      lastRevenue: utils.number.addSymbol(this.contract?.last_revenue),
      lastRevenueColor: getColor(this.$store, this.contract?.last_revenue),
      totalRevenueColor: getColor(this.$store, totalRevenue),
      rateColor: getColor(this.$store, interestRatio)
    };
  }

  handleToJoin() {
    this.$common.utils.helper.toFusionPath(this, "defi", {
      name: "type-id",
      params: {
        type: this.contract?.type ?? "",
        id: this.contract?.scheme_id ?? ""
      }
    });
  }

  async handleWithdraw() {
    if (!this.contract) return;
    this.withdrawing = true;
    await this.requestWithdraw(this.contract.id);
    this.withdrawing = false;
  }

  async requestWithdraw(id) {
    try {
      await this.$api.defi.requestWithdraw(id, {});
      this.$common.utils.helper.toast(this, {
        message: this.$t("defi.withdraw-apply-success") as string,
        color: "success"
      });
      this.$emit("refresh");
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default TermContractDetail;
